import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import PerText from '../Text'
import PerFlexRow from '../FlexRow'

interface Props {
  targetBonus: number
  plannedBonus: number
  remainingBonus: number
  cannotProceed: boolean
  formatCurrencyCallback?: (amount: number) => string
}

export const NewTargetsFooter: FC<Props> = ({ targetBonus, plannedBonus, remainingBonus, formatCurrencyCallback, cannotProceed }) => {
  const [t] = useTranslation()

  const formatCurrency = formatCurrencyCallback ? formatCurrencyCallback : (a: number) => `${a} C`

  return (
    <>
      <PerFlexRow>
        <div>
          <PerText appearance="footer-label-small">{t('appraisalMeeting.stepNewGoals.footer.annualTargetBonus')}</PerText>
          <PerText appearance="footer-label-small">{t('appraisalMeeting.stepNewGoals.footer.difference')}</PerText>
        </div>
        <div>
          <PerText appearance="footer-input-small">{formatCurrency(targetBonus)}</PerText>
          <PerText appearance="footer-input-small" color={cannotProceed ? 'error' : undefined}>
            {formatCurrency(remainingBonus)}
          </PerText>
        </div>
      </PerFlexRow>

      <PerFlexRow>
        <PerText appearance="footer-label">{t('appraisalMeeting.stepNewGoals.footer.plannedTargetBonus')}</PerText>
        <PerText appearance="footer-input">{formatCurrency(plannedBonus)}</PerText>
      </PerFlexRow>
    </>
  )
}
